<template>
  <section
    id="enjuapp"
    class="l-enjuapp"
  >
    <div class="o-container">
      <div class="o-separator -line -gray t-xs-hide t-md-block">
        <hr>
      </div>

      <div class="o-grid -xs-middle -xs-full -xs-between">
        <div class="o-grid__item l-bag__grid -xs-24 -md-11">
          <h2 class="l-enjuapp__title">
            não deixe pra baixar amanhã o que você pode baixar agora
          </h2>

          <h3 class="l-enjuapp__subtitle">
            mais que um app. é o enju-app.
          </h3>

          <p class="l-enjuapp__description">
            descontos relâmpagos, agilidade na negociação
            <span class="t-md-block">
              e promos exclusivas. é fogo no parquinho.
            </span>
          </p>

          <a
            v-webview-open-universal-link="'none'"
            href="/app"
          >
            <button
              class="l-enjuapp__button o-button -xs-large -xs-secondary t-xs-block t-md-hide"
            >

              baixar o enjuapp
            </button>
          </a>

          <a
            href="https://apps.apple.com/us/app/enjoei-comprar-e-vender-roupa/id783409492"
            target="_blank"
            class="l-action-desktop"
          >
            <button
              class="l-enjuapp__button-desktop o-button -xs-large -xs-secondary t-xs-hide t-md-block"
            >

              <vIcon
                class="l-enjuapp__button-icon"
                name="apple"
                size="medium"
                color="dark"
              />

              baixar na app store
            </button>
          </a>

          <a
            href="https://play.google.com/store/apps/details?id=br.com.enjoei.app&hl=pt_BR&gl=US"
            target="_blank"
            class="l-action-desktop"
          >
            <button
              class="l-enjuapp__button-desktop o-button -xs-large -xs-secondary t-xs-hide t-md-block"
            >

              <img
                class="l-enjuapp__button-image"
                :src="`${require('@@/assets/images/landing-pages/how-to/enjuapp/google-play.png')}`"
                alt="Logo ilustrativo da Google Play Store"
              >

              baixar na google play
            </button>
          </a>
        </div>

        <div class="o-grid__item l-bag__grid -xs-24 -md-13">
          <div class="l-enjuapp__wrapper">
            <figure class="l-enjuapp__figure l-figure">
              <picture>
                <source
                  :srcset="`
                    ${require('@@/assets/images/landing-pages/how-to/enjuapp/cellphone-xs.png')},
                    ${require('@@/assets/images/landing-pages/how-to/enjuapp/cellphone-xs@2x.png')} 2x
                  `"
                  media="(max-width: 899px)"
                >

                <source
                  :srcset="`
                    ${require('@@/assets/images/landing-pages/how-to/enjuapp/cellphones-md.png')},
                    ${require('@@/assets/images/landing-pages/how-to/enjuapp/cellphones-md@2x.png')} 2x
                  `"
                  media="(min-width: 900px)"
                >

                <img
                  class="l-image"
                  :src="`${require('@@/assets/images/landing-pages/how-to/enjuapp/cellphones-md.png')}`"
                  alt="Imagem ilustrativa de um celular exibindo a página inicial do aplicativo do enjoei."
                >
              </picture>
            </figure>
          </div>
        </div>
      </div>

      <div class="o-separator -line -gray t-xs-hide t-md-block">
        <hr>
      </div>

      <div class="l-enjuapp__prefooter">
        <a
          v-webview-open-universal-link="'none'"
          :href="content.actionLink"
          class="l-enjuapp__action o-button -xs-large -xs-primary"
        >
          {{ content.actionText }}
        </a>
      </div>
    </div>
  </section>
</template>

<script>
  import webviewOpenUniversalLink from '@/tools/directives/webview-open-universal-link'

  import vIcon from '@/web/components/icon.vue'

  import { CONTENTS } from './constants'

  export default {
    directives: {
      webviewOpenUniversalLink
    },
    components: {
      vIcon
    },
    props: {
      mode: {
        type: String,
        required: true
      }
    },
    computed: {
      content() {
        return CONTENTS[this.mode]
      }
    }
  }
</script>

<style lang="scss" scoped>
  .l-enjuapp {
    margin: 88px 0 0;
    padding: 0 20px;
    text-align: left;

    &__title {
      font-size: 28px;
      font-weight: $font-weight-extra-bold;
      line-height: 32px;

      @include breakpoint(md) {
        font-size: 40px;
        line-height: 44px;
      }
    }

    &__subtitle {
      font-size: 20px;
      line-height: 24px;
      margin: 24px 0;

      @include breakpoint(md) {
        font-size: 24px;
        line-height: 32px;
        margin: 56px auto 24px;
      }
    }

    &__description {
      line-height: 24px;
      margin: 24px auto 32px;
    }

    &__button {
      width: 100%;
      font-weight: $font-weight-bold;

      @include breakpoint(md) {
        width: auto;
      }

      &-desktop {
        min-width: 223px;
        text-align: left;
        font-size: $font-size-xs;
        font-weight: $font-weight-semi-bold;
        color: $color-neutral-800;
        border: 1px solid $color-neutral-500;

        &:hover {
          background-color: $color-grayscale-white;
          border-color: $color-primary;
          color: $color-neutral-800;
        }

        &:last-child {
          margin-top: 8px;
        }
      }

      &-icon {
        margin: auto 10px auto 8px;
        vertical-align: middle;
      }

      &-image {
        margin: auto 16px auto 8px;
        width: 18px;
        vertical-align: middle;
      }
    }

    &__wrapper {
      margin: 40px auto 0;
      position: relative;
      height: 262px;
      width: 335px;
      display: flex;
      justify-content: center;

      @include breakpoint(md) {
        margin: 0;
        height: auto;
        width: auto;
        justify-content: right;
      }
    }

    &__figure {
      margin: 0;
      width: auto;

      @include breakpoint(md) {
        width: 100%;
      }
    }

    &__prefooter {
      text-align: center;
      margin-bottom: 32px;

      @include breakpoint(md) {
        margin-bottom: 0;
      }

      &-figure {
        margin: 0;

        @include breakpoint(md) {
          margin: 96px auto 4px;
        }
      }
    }

    &__icon {
      font-size: 36px;
      text-align: center;

      @include breakpoint(md) {
        margin-top: 66px;
      }
    }

    &__action {
      margin: 40px 0 0;
      width: 100%;
      text-transform: lowercase;
      font-weight: $font-weight-bold;

      @include breakpoint(md) {
        width: auto;
        margin: 80px auto 20px;
      }
    }
  }

  .o-separator {
    margin-top: -5px;
  }

  .o-container {
    max-width: 1067px;
  }

  .l-image {
    width: 100%;
    border-bottom: 1px solid $color-image-background;

    @include breakpoint(md) {
      border: none;
    }
  }

  .l-action-desktop {
    display: block;
    max-width: 252px;

    .o-button {
      width: 100%;
    }
  }
</style>
